import { apiFetch } from '../../apiFetch'
export const postQueue = async (payload) => {
  const req = await apiFetch({
    method: 'POST',
    path: '/queue',
    payload
  })

  return await req
}

export const putQueue = async (payload) => {
  const req = await apiFetch({
    method: 'POST',
    path: `/queues/${payload.id}`,
    payload
  })

  return await req
}
